import { IStatusPill } from 'types/ui/statusPill.interface'
import { OpsCoreState, OpsTaskSource, OpsAlertSeverity } from 'types/operationsControl.interface'

export const USE_OPS_MOCKS = process.env.REACT_APP_OPS_MOCKS !== 'false'

export const CORE_STATE_META: { [k in OpsCoreState]: { label: string; tone: IStatusPill['status'] } } = {
  DRAFT: { label: 'Draft', tone: 'info' },
  ACTIVE: { label: 'Active', tone: 'success' },
  PAUSED: { label: 'Paused', tone: 'warning' },
  BLOCKED: { label: 'Blocked', tone: 'danger' },
  COMPLETED: { label: 'Completed', tone: 'info' },
  CANCELLED: { label: 'Cancelled', tone: 'neutral' },
}

const TASK_ENUM_TO_CORE: { [k: number]: OpsCoreState } = {
  0: 'DRAFT',
  1: 'ACTIVE',
  2: 'PAUSED',
  3: 'COMPLETED',
  4: 'BLOCKED',
  5: 'PAUSED',
  6: 'PAUSED',
  7: 'CANCELLED',
}

export const TASK_ENUM_SUBSTATE: { [k: number]: string } = {
  0: 'Not started',
  1: 'In progress',
  2: 'Paused',
  3: 'Completed',
  4: 'Reported — needs review',
  5: 'Idle — waiting on input',
  6: 'Able to continue',
  7: 'Stopped',
}

export const taskCoreState = (taskStatus: number): OpsCoreState => TASK_ENUM_TO_CORE[taskStatus] ?? 'DRAFT'

export const PLAN_STATUS_TO_CORE: { [k: number]: OpsCoreState } = {
  1: 'DRAFT',
  2: 'ACTIVE',
  3: 'PAUSED',
  4: 'COMPLETED',
  5: 'CANCELLED',
}

export const SOURCE_META: { [k in OpsTaskSource]: { label: string; tone: IStatusPill['status'] } } = {
  PLAN: { label: 'Plan', tone: 'accent' },
  SHIFT_PROGRAM: { label: 'Shift program', tone: 'info' },
  TRIGGER: { label: 'Trigger', tone: 'warning' },
  MANUAL: { label: 'Manual', tone: 'neutral' },
  REQUEST: { label: 'Request', tone: 'accent' },
}

export const ALERT_SEVERITY_META: { [k in OpsAlertSeverity]: { label: string; tone: IStatusPill['status'] } } = {
  critical: { label: 'Critical', tone: 'danger' },
  warning: { label: 'Warning', tone: 'warning' },
  info: { label: 'Info', tone: 'info' },
}

export const etaLabel = (etaMin: number | null): string => {
  if (etaMin == null) return '—'
  if (etaMin < 60) return `${etaMin}m`
  return `${Math.floor(etaMin / 60)}h ${etaMin % 60}m`
}
